import { Component, OnInit, ViewChild } from '@angular/core';
import { EventListFilterComponent } from '../event-list-filter/event-list-filter.component';

// Classes.
import { EventListFilterConf } from '../../classes/event-list-filter.conf'
import { EventListPagerConf } from '../../classes/event-list-pager.conf'


@Component({
  selector: 'event-list-widget',
  templateUrl: './event-list-widget.component.html',
  styleUrls: ['./event-list-widget.component.scss']
})
export class EventListWidgetComponent implements OnInit {


  constructor() { }

  ngOnInit() {
  }


}
